import { FC } from "react";
import { Link } from "react-router-dom";
import { Vacancy } from "../../home/models/Vacancies";
import { DATE_OPTIONS, formatDate } from "../../../utilities/dateUtilities";

/**
 * TODO: Pass Job Header properties
 * TODO: API Call to get job details
 * @returns
 */

export const JobHeader: FC<{ vacancy: Vacancy }> = ({ vacancy }) => {
  return (
    <div className="z-20 py-5 bg-white border-b top-8 sm:top-14 lg:flex lg:items-center lg:justify-between">
      <div className="flex-1 min-w-0">
        <h2 className="text-lg font-bold leading-7 text-gray-700 sm:truncate sm:text-3xl sm:tracking-tight">
          {vacancy.title}
        </h2>
        <div className="flex flex-col mt-3 sm:mt-0 sm:flex-row sm:flex-wrap sm:space-x-1">
          {vacancy.department && (
            <span className="text-sm text-gray-600">
              {vacancy.department} •
            </span>
          )}

          <span className="text-sm text-gray-600">{vacancy.location} •</span>
          <span className="text-sm text-gray-600">{`Posted: ${formatDate(
            new Date(vacancy.datePosted),
            DATE_OPTIONS.dMY
          )}`}</span>
        </div>
      </div>
      {!vacancy.isClosed && (
        <div className="flex mt-5 lg:ml-4 lg:mt-0">
          <span className="">
            <a
              href="#apply-section"
              className="inline-flex items-center px-3 py-2 text-sm font-semibold text-white rounded-md shadow-sm bg-primary-600 hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600"
            >
              Apply for this Job
            </a>
          </span>
        </div>
      )}
    </div>
  );
};
